import ReactDOM from "react-dom";
import { FaRegSun } from "react-icons/fa";

import CustomerSidebar from "customer-panel/CustomerSidebar";

export default function PanelModal() {
  return (
    <>
      <button
        type="button"
        className="btn d-flex d-md-none me-1 align-items-center"
        data-bs-toggle="modal"
        data-bs-target="#the-panel-modal"
        style={{
          color: "rgb(70, 66, 66",
          borderColor: "rgba(0,0,0,.1)",
          backgroundColor: "#ffffff",
        }}
      >
        <FaRegSun style={{ fontSize: "20px" }} />
      </button>
      {ReactDOM.createPortal(
        <div
          className="modal fade"
          id="the-panel-modal"
          tabIndex="-1"
          aria-labelledby="#panelModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="panelModalLabel">
                  پنل کاربری
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <CustomerSidebar classProp={"d-flex"}></CustomerSidebar>
              </div>
            </div>
          </div>
        </div>,
        document.querySelector(".modals")
      )}
    </>
  );
}
